(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        initChartMobileControls();
        initCustomSelects();
    });

    function initChartMobileControls() {
        const rangeSelect = document.getElementById('chartRangeSelect');
        const typeSelect = document.getElementById('chartTypeSelect');

        if (!rangeSelect || !typeSelect) {
            return;
        }

        rangeSelect.addEventListener('change', function() {
            const selectedRange = this.value;

            const rangeButtons = document.querySelectorAll('.currency-chart__btn');
            rangeButtons.forEach(btn => {
                btn.classList.remove('currency-chart__btn--active');
            });

            const targetButton = document.querySelector(`.currency-chart__btn[data-range="${selectedRange}"]`);
            if (targetButton) {
                targetButton.click();
                targetButton.classList.add('currency-chart__btn--active');
            }
        });

        typeSelect.addEventListener('change', function() {
            const selectedType = this.value;

            const typeButtons = document.querySelectorAll('.currency-chart__type-btn');
            typeButtons.forEach(btn => {
                btn.classList.remove('currency-chart__type-btn--active');
            });

            const targetButton = document.querySelector(`.currency-chart__type-btn[data-type="${selectedType}"]`);
            if (targetButton) {
                targetButton.click();
                targetButton.classList.add('currency-chart__type-btn--active');
            }
        });

        const rangeButtons = document.querySelectorAll('.currency-chart__btn');
        rangeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const range = this.getAttribute('data-range');
                if (rangeSelect && range) {
                    rangeSelect.value = range;
                }
            });
        });

        const typeButtons = document.querySelectorAll('.currency-chart__type-btn');
        typeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const type = this.getAttribute('data-type');
                if (typeSelect && type) {
                    typeSelect.value = type;
                }
            });
        });
    }

    function initCustomSelects() {
        const customSelects = document.querySelectorAll('.currency-chart__custom-select');

        customSelects.forEach(select => {
            const trigger = select.querySelector('.currency-chart__custom-select-trigger');
            const options = select.querySelectorAll('.currency-chart__custom-select-option');
            const selectType = select.getAttribute('data-select-type');

            if (!trigger || !options.length) {
                return;
            }

            trigger.addEventListener('click', function(e) {
                e.stopPropagation();

                customSelects.forEach(s => {
                    if (s !== select) s.classList.remove('is-open');
                });

                select.classList.toggle('is-open');
            });

            options.forEach(option => {
                option.addEventListener('click', function() {
                    const value = this.getAttribute('data-value');
                    const text = this.textContent.trim();

                    const triggerText = trigger.querySelector('span');
                    if (triggerText) {
                        triggerText.textContent = text;
                    }

                    options.forEach(opt => opt.removeAttribute('data-selected'));
                    this.setAttribute('data-selected', 'true');

                    select.classList.remove('is-open');

                    if (selectType === 'range') {
                        const rangeButtons = document.querySelectorAll('.currency-chart__btn');
                        rangeButtons.forEach(btn => {
                            btn.classList.remove('currency-chart__btn--active');
                        });

                        const rangeBtn = document.querySelector(`[data-range="${value}"]`);
                        if (rangeBtn) {
                            rangeBtn.click();
                            rangeBtn.classList.add('currency-chart__btn--active');
                        }

                        const nativeSelect = document.getElementById('chartRangeSelect');
                        if (nativeSelect) {
                            nativeSelect.value = value;
                        }
                    } else if (selectType === 'type') {
                        const typeButtons = document.querySelectorAll('.currency-chart__type-btn');
                        typeButtons.forEach(btn => {
                            btn.classList.remove('currency-chart__type-btn--active');
                        });

                        const typeBtn = document.querySelector(`[data-type="${value}"]`);
                        if (typeBtn) {
                            typeBtn.click();
                            typeBtn.classList.add('currency-chart__type-btn--active');
                        }

                        const nativeSelect = document.getElementById('chartTypeSelect');
                        if (nativeSelect) {
                            nativeSelect.value = value;
                        }
                    }
                });
            });
        });

        document.addEventListener('click', function() {
            customSelects.forEach(select => {
                select.classList.remove('is-open');
            });
        });

        const rangeButtons = document.querySelectorAll('.currency-chart__btn');
        rangeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const range = this.getAttribute('data-range');
                const customSelect = document.querySelector('.currency-chart__custom-select[data-select-type="range"]');

                if (customSelect && range) {
                    const option = customSelect.querySelector(`.currency-chart__custom-select-option[data-value="${range}"]`);
                    const trigger = customSelect.querySelector('.currency-chart__custom-select-trigger span');

                    if (option && trigger) {
                        const allOptions = customSelect.querySelectorAll('.currency-chart__custom-select-option');
                        allOptions.forEach(opt => opt.removeAttribute('data-selected'));
                        option.setAttribute('data-selected', 'true');

                        trigger.textContent = option.textContent.trim();
                    }
                }
            });
        });

        const typeButtons = document.querySelectorAll('.currency-chart__type-btn');
        typeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const type = this.getAttribute('data-type');
                const customSelect = document.querySelector('.currency-chart__custom-select[data-select-type="type"]');

                if (customSelect && type) {
                    const option = customSelect.querySelector(`.currency-chart__custom-select-option[data-value="${type}"]`);
                    const trigger = customSelect.querySelector('.currency-chart__custom-select-trigger span');

                    if (option && trigger) {
                        const allOptions = customSelect.querySelectorAll('.currency-chart__custom-select-option');
                        allOptions.forEach(opt => opt.removeAttribute('data-selected'));
                        option.setAttribute('data-selected', 'true');

                        trigger.textContent = option.textContent.trim();
                    }
                }
            });
        });
    }
})();